export default {
    slider: {
      new: "New Chat",
      history: "History",
      macro: "Macro",
      delete: "Delete",
      rename: "Rename",
      pin:"Pin",
      unpin:"Unpin",
    },
    homepage:{
      logout: "Logout",
    },
    input:{
        api:"API",
        knowledge:"Knowledge",
        preWorld:"Enter your question in detail here",
    },

    messageRow:{
      reference:"Reference:",
      copy:"copy",
      good:"good response",
      bad:"bad response",

    },

    contextmenu:{
      copy:"Copy    Ctrl+X",
      paste:"Paste    Ctrl+V",
      cut:"Cut    Ctrl+X",
    
    },

    commandSuggestion:{
      suggestion:"Whether to execute the {name} command?",
    }
  }
  